
import React from "react";

const EmpAssignmentPopup = ({ openAssignmentPopup, empdata,empChangeHandler,submitEmpAssignment }) => (
    <div className="background-blur-external">
        <div className="popup-contact-us text-center" style={{ height: 'auto' }}>
            <i className="fa fa-close" onClick={() => openAssignmentPopup('close')} style={{ float: 'right', cursor: 'pointer' }}></i>

            <div className="row">
                <h5> Assign Employee</h5>
                <div className="col-sm-2 col-xs-12"></div>
                <div className="col-sm-8 col-xs-12">
                    { console.log(empdata)}
                    <select className="form-control select-field-assign" onChange={(e)=>empChangeHandler(e)} >
                        <option value='' >Select Employee</option>
                        {empdata ? empdata.map((data, i) => {
                           
                            return (
                                <option value={data.code} >{data.name}</option>
                            )
                        }) : ""}


                    </select>
                    <div style={{ marginTop: '20px' }}>
                        <button className="cred-btn" onClick={()=>submitEmpAssignment()}>Save</button>
                    </div>
                </div>
                <div className="col-sm-2 col-xs-12"></div>

            </div>
        </div>

    </div>
)
export default EmpAssignmentPopup